import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/founder/premium-notifications.webp")